export default "__VITE_ASSET__B70w8hvH__"